module.exports = __webpack_public_path__ + "img/0xf21768ccbc73ea5b6fd3c687208a7c2def2d966e.fbd5664f.png";